"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SystemNotificationType;
(function (SystemNotificationType) {
    SystemNotificationType[SystemNotificationType["SystemNotification"] = 1] = "SystemNotification";
    SystemNotificationType[SystemNotificationType["TenantNotification"] = 2] = "TenantNotification";
})(SystemNotificationType || (SystemNotificationType = {}));
exports.default = SystemNotificationType;
